/**
 * Created by Josef Jurca on 02/08/2017.
 */

// Action types
const ActionTypes = {
        ADD: 'ADD_IMAGE_QUEUE',
        REMOVE: 'REMOVE_IMAGE_QUEUE',
        SET_LOADING_STATUS: 'SET_IMAGES_QUEUE_STATUS'
    },
    ImagesQueueStatuses = {
        INITIAL: 'INITIAL',
        IN_PROGRESS: 'IN_PROGRESS',
        LOADING_FINISHED: 'LOADING_FINISHED'
    };

/**
 * Sets loading images status.
 *
 * @param {string} status - Status;.
 * @returns {Object} Action type.
 */
function setStatus (status) {

    return {
        type: ActionTypes.SET_LOADING_STATUS,
        status: status
    };
}

/**
 * Increases loading images queue.
 *
 * @param {number} id - Asset ID;.
 * @returns {Object} Action type.
 */
function addImage (id) {

    return {
        type: ActionTypes.ADD,
        id
    };
}

/**
 * Decreases loading images queue.
 *
 * @param {number} id - Asset ID;.
 * @returns {Object} Action type.
 */
function removeImage (id) {

    return {
        type: ActionTypes.REMOVE,
        id
    };
}


// Exposed elements of the actions file.
export {
    ActionTypes,
    addImage,
    removeImage,
    setStatus,
    ImagesQueueStatuses
};


// WEBPACK FOOTER //
// ./src/js/store/actions/imagesqueue.js